class OiBlogOverview {
    private blogOverview: HTMLElement;

    constructor(blogOverview: HTMLElement) {
        this.blogOverview = blogOverview;
        const filters = this.blogOverview.querySelectorAll<HTMLInputElement>('input[name="blog-category"]');
        const teasers = this.blogOverview.querySelectorAll<HTMLElement>('[data-blogcategories]');

        filters.forEach((filter) => {
            filter.addEventListener("change", () => {
                const selectedCategory = filter.value;

                teasers.forEach((teaser) => {
                    const categoryAttr = teaser.dataset.blogcategories?.trim() || "";
                    const categories = categoryAttr.split(/\s+/);

                    if (
                        selectedCategory === "all" || categories.includes(selectedCategory)
                    ) {
                        teaser.classList.remove("hidden");
                    } else {
                        teaser.classList.add("hidden");
                    }
                });
            });
        });
    }

}

export default OiBlogOverview;
